export default __webpack_public_path__ + "media/zurb/img/home/Facebook-f36481d7b41e0bb2ff9a6bd75752cfd6.svg";